import { InjectionToken } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

export const LOGIN_PAGE_CONFIG = new InjectionToken<LoginPageConfig>('LoginPageConfig');

export interface LoginPageConfig {
  redirectUrl?: string[];
  redirectFunction?: (router: Router) => { commands: string[]; extra?: NavigationExtras };
  additionalScopesFactory?: (activatedRoute: ActivatedRoute) => string[];
}
